module.exports = __webpack_public_path__ + "static/media/phlog.ef49cedd.png";